import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getAllMovies } from '@/utils/movie';

export default function About() {
  const total = getAllMovies().length;

  useEffect(() => {
    document.title = '关于本站 - 李采潭电影';
    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute('content', '了解李采潭电影网站的定位、内容范围、联系方式以及版权与免责声明。');
  }, []);

  const values = [
    { icon: 'ri-database-2-line', title: '资料完整', text: '覆盖片名、年份、类型、时长、导演、主演与详细剧情简介，信息一步到位。' },
    { icon: 'ri-layout-grid-line', title: '查找高效', text: '支持关键词模糊搜索、多维度筛选与排序，海量作品也能快速定位。' },
    { icon: 'ri-shield-check-line', title: '内容合规', text: '所有影片资料与图片均为虚拟示例，不含真实版权内容，仅用于展示。' },
  ];

  return (
    <div className="w-full">
      <div className="w-full bg-primary-900 text-background-50">
        <div className="w-full px-4 md:px-8 py-14 md:py-20">
          <nav className="flex items-center flex-wrap gap-2 text-xs text-primary-200/80 mb-4">
            <Link to="/" className="hover:text-accent-300 transition-colors cursor-pointer">首页</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-accent-300">关于</span>
          </nav>
          <h1 className="font-heading text-3xl md:text-5xl font-bold max-w-3xl">关于「李采潭电影」</h1>
          <p className="text-sm md:text-base text-primary-200/85 mt-4 max-w-2xl leading-relaxed">
            一个专注于李采潭主演及相关影视作品的信息聚合站点，为影迷提供清晰、完整、易于检索的作品资料。
          </p>
        </div>
      </div>

      <div className="w-full px-4 md:px-8 py-14 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
          <div className="lg:col-span-2 space-y-12">
            <section>
              <h2 className="font-heading text-2xl font-bold text-foreground-950 mb-4">网站定位</h2>
              <div className="rounded-lg bg-background-100 border border-background-200 p-6">
                <p className="text-sm md:text-base text-foreground-700 leading-loose">
                  本站面向对李采潭影视作品感兴趣的普通观众与影迷，核心目标是让大家能够方便地浏览其主演及相关作品的完整资料，
                  并通过详细的剧情介绍快速判断一部影片是否符合自己的观影口味。
                </p>
                <p className="text-sm md:text-base text-foreground-700 leading-loose mt-4">
                  目前站点共收录 <span className="font-semibold text-primary-700">{total}</span> 部演示作品，涵盖剧情、爱情、悬疑、犯罪、
                  家庭、科幻、历史等多种类型。你可以通过分类页按类型、年代与评分筛选，也可以直接使用搜索功能定位想看的那一部。
                </p>
                <p className="text-sm md:text-base text-foreground-700 leading-loose mt-4">
                  本站不提供会员、登录、在线播放或下载功能，所有内容均为资料与介绍性质的展示。
                </p>
              </div>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-bold text-foreground-950 mb-5">我们的坚持</h2>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                {values.map((v) => (
                  <div key={v.title} className="rounded-lg bg-background-50 border border-background-200 p-5">
                    <span className="w-11 h-11 flex items-center justify-center rounded-md bg-accent-100 text-accent-700 mb-4">
                      <i className={`${v.icon} text-xl`}></i>
                    </span>
                    <h3 className="font-heading text-base font-semibold text-foreground-950 mb-2">{v.title}</h3>
                    <p className="text-xs text-foreground-600 leading-relaxed">{v.text}</p>
                  </div>
                ))}
              </div>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-bold text-foreground-950 mb-4">联系与反馈</h2>
              <div className="rounded-lg bg-background-50 border border-background-200 p-6">
                <p className="text-sm text-foreground-700 leading-relaxed">
                  如果你对本站内容有任何建议、补充或反馈，欢迎通过以下方式联系我们。我们会在收到后尽快查看并处理。
                </p>
                <div className="flex flex-col sm:flex-row gap-3 mt-5">
                  <a
                    href="mailto:hello@example.com"
                    className="inline-flex items-center justify-center gap-2 h-11 px-6 rounded-md bg-primary-700 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-800 transition-colors cursor-pointer"
                  >
                    <i className="ri-mail-send-line"></i>hello@example.com
                  </a>
                  <Link
                    to="/category"
                    className="inline-flex items-center justify-center gap-2 h-11 px-6 rounded-md border border-background-300 text-foreground-700 text-sm font-medium whitespace-nowrap hover:bg-background-100 transition-colors cursor-pointer"
                  >
                    <i className="ri-grid-line"></i>浏览电影分类
                  </Link>
                </div>
                <p className="text-xs text-foreground-500 mt-4">点击邮箱地址将打开你的邮件客户端（演示联系方式）。</p>
              </div>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-bold text-foreground-950 mb-4">版权与免责声明</h2>
              <div className="rounded-lg bg-secondary-50 border border-secondary-200 p-6 space-y-3 text-sm text-secondary-900 leading-relaxed">
                <p>1. 本站为虚构的演示站点，所有影片名称、年份、导演、主演、剧情简介及图片均为示例内容，不代表任何真实影视作品。</p>
                <p>2. 本站不含任何真实版权作品的片段、剧照或音视频内容，所有图片均由 AI 生成，仅用于页面展示。</p>
                <p>3. 本站不提供、不建议任何形式的盗版资源获取方式，也不提供在线播放与下载服务。</p>
                <p>4. 如本站内容无意中侵犯了你的权益，请通过上方邮箱与我们联系，我们会及时处理。</p>
              </div>
            </section>
          </div>

          <aside className="lg:col-span-1">
            <div className="lg:sticky lg:top-20 space-y-5">
              <div className="rounded-lg bg-primary-900 p-6 text-background-50">
                <h3 className="font-heading text-lg font-bold mb-4">站点速览</h3>
                <dl className="space-y-3 text-sm">
                  <div className="flex items-center justify-between">
                    <dt className="text-primary-200/80">收录作品</dt>
                    <dd className="font-semibold text-accent-300">{total} 部</dd>
                  </div>
                  <div className="flex items-center justify-between">
                    <dt className="text-primary-200/80">影片类型</dt>
                    <dd className="font-semibold text-accent-300">12 类</dd>
                  </div>
                  <div className="flex items-center justify-between">
                    <dt className="text-primary-200/80">内容更新</dt>
                    <dd className="font-semibold text-accent-300">每周</dd>
                  </div>
                  <div className="flex items-center justify-between">
                    <dt className="text-primary-200/80">站点性质</dt>
                    <dd className="font-semibold text-accent-300">资料展示</dd>
                  </div>
                </dl>
              </div>
              <div className="rounded-lg bg-background-50 border border-background-200 p-6">
                <h3 className="font-heading text-base font-semibold text-foreground-950 mb-3">快速导航</h3>
                <ul className="space-y-2 text-sm">
                  <li><Link to="/" className="flex items-center gap-2 text-foreground-700 hover:text-primary-700 transition-colors cursor-pointer"><i className="ri-home-4-line"></i>返回首页</Link></li>
                  <li><Link to="/category" className="flex items-center gap-2 text-foreground-700 hover:text-primary-700 transition-colors cursor-pointer"><i className="ri-grid-line"></i>电影分类</Link></li>
                  <li><Link to="/search" className="flex items-center gap-2 text-foreground-700 hover:text-primary-700 transition-colors cursor-pointer"><i className="ri-search-line"></i>搜索影片</Link></li>
                </ul>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </div>
  );
}